const {Router} = require('../../../js/common/router');
const tts = require('../../common/js/_tts');
const lang = document.documentElement.lang;

export function addItem(currentItem) {
    $.ajax({
        url: Router.generate('request_add.' + lang, {'showroom': document.documentElement.getAttribute('data-showroom')}),
        data: {
            items: [
                {
                    slug: currentItem['slug'],
                    photo: currentItem['medias'][0]['list'],
                    designer: currentItem['designerName'],
                    season: currentItem['seasonName'],
                    look: currentItem['look'],
                    reference: currentItem['reference'],
                }
            ]
        },
        method: "POST",
        statusCode: {
            403: function () {
                window.location.href = Router.generate(
                    'login' + '.' + document.documentElement.getAttribute('data-showroom') + '.' + lang
                )
            }
        },
        success: function () {
            $('#modal-add-success').modal('show');
            tts.photo(currentItem['slug'], 'request_add');
        }
    }).fail(function (xhr) {
        if (xhr.status !== 403) {
            $('#modal-error').modal('show');
        }
    }).always(function () {
        $('#loading-overlay').fadeOut();
    });
}
